import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { getAdminSalesVideoTemplates, setAdminSalesVideoTemplateActive } from "@/lib/api";

export default function AdminSalesVideoTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [acting, setActing] = useState(null);
  const mounted = useRef(false);
  const guard = useRef(false);
  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const data = await getAdminSalesVideoTemplates();
      if (mounted.current) setTemplates(data.templates || []);
    } catch { if (mounted.current) setError(true); }
    finally { if (mounted.current) setLoading(false); }
  }, []);
  useEffect(() => {
    mounted.current = true;
    load();
    return () => { mounted.current = false; };
  }, [load]);
  const toggle = async (template) => {
    if (guard.current) return;
    guard.current = true;
    setActing(template.id);
    try {
      const data = await setAdminSalesVideoTemplateActive(template.id, !template.active);
      if (!mounted.current) return;
      setTemplates((items) => items.map((item) => item.id === template.id ? data.template : item));
      toast.success("Status template disimpan.");
    } catch { if (mounted.current) toast.error("Gagal memperbarui template."); }
    finally { guard.current = false; if (mounted.current) setActing(null); }
  };
  return (
    <div className="max-w-3xl space-y-4" data-testid="admin-sales-video-templates">
      <h2 className="font-heading text-lg font-bold text-white">Template Video Jualan</h2>
      <p className="text-sm text-slate-400">Template aktif dapat dipilih untuk project baru. Project yang sudah tersimpan memakai konfigurasi template yang tersimpan.</p>
      {loading && <p className="flex items-center gap-2 text-sm text-slate-400"><Loader2 className="h-4 w-4 animate-spin" />Memuat template…</p>}
      {error && <p role="alert" className="text-sm text-red-400">Gagal memuat template. <button className="underline" onClick={load}>Coba kembali</button></p>}
      {!loading && !error && !templates.length && <p className="text-sm text-slate-400">Template belum tersedia.</p>}
      {templates.map((template) => <div key={template.id} className="rounded-xl border border-slate-800 bg-slate-900 p-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="min-w-0 flex-1"><p className="break-words font-semibold text-white">{template.name}</p><p className="mt-2 break-words text-sm text-slate-400">{template.description}</p><p className="mt-2 text-xs text-slate-500">{template.default_duration_seconds} detik</p></div>
          <button disabled={Boolean(acting)} onClick={() => toggle(template)} aria-label={`${template.active ? "Nonaktifkan" : "Aktifkan"} ${template.name}`}
            data-testid={`toggle-template-${template.id}`} className={`rounded-full px-4 py-2 text-sm font-semibold disabled:opacity-50 ${template.active ? "bg-emerald-600 text-white" : "bg-slate-700 text-slate-200"}`}>
            {acting === template.id ? "Menyimpan…" : template.active ? "ON" : "OFF"}
          </button>
        </div>
      </div>)}
    </div>
  );
}
